/**
 * LP 見学予約スケジュール
 * SP: 7日ずつ1行で週切り替え
 * PC: 14日×2行を固定表示（JS不要）
 */

const BP_MD = 768;
const DAYS_PER_WEEK = 7;

class LpViewingSchedule {
    constructor(root) {
        this.root = root;
        this.weekRow = root.querySelector('.js-lp-viewing-schedule-week');
        this.continuationRow = root.querySelector('.c-section-lp-viewing-schedule__row--continuation');
        this.weekCols = Array.from(this.weekRow?.querySelectorAll('.c-section-lp-viewing-schedule-col') ?? []);
        this.continuationCols = Array.from(this.continuationRow?.querySelectorAll('.c-section-lp-viewing-schedule-col') ?? []);
        this.btnPrev = root.querySelector('.js-lp-viewing-schedule-prev');
        this.btnNext = root.querySelector('.js-lp-viewing-schedule-next');

        if ((!this.weekCols.length && !this.continuationCols.length) || !this.btnPrev || !this.btnNext) {
            return;
        }

        this.mq = window.matchMedia(`(max-width: ${BP_MD}px)`);
        this.offset = 0;

        this.mq.addEventListener('change', () => {
            this.offset = 0;
            this.render();
        });

        this.btnPrev.addEventListener('click', () => {
            this.offset = Math.max(0, this.offset - 1);
            this.render();
        });

        this.btnNext.addEventListener('click', () => {
            this.offset = Math.min(this.maxOffset(), this.offset + 1);
            this.render();
        });

        this.render();
    }

    isSp() {
        return this.mq.matches;
    }

    totalWeeks() {
        return Math.ceil((this.weekCols.length + this.continuationCols.length) / DAYS_PER_WEEK);
    }

    maxOffset() {
        return Math.max(0, this.totalWeeks() - 1);
    }

    render() {
        if (!this.isSp()) {
            this.weekCols.forEach((col) => col.removeAttribute('data-hidden'));
            this.continuationCols.forEach((col) => col.removeAttribute('data-hidden'));
            this.weekRow?.removeAttribute('data-hidden');
            this.continuationRow?.removeAttribute('data-hidden');
            this.btnPrev.disabled = true;
            this.btnNext.disabled = true;
            return;
        }

        const start = this.offset * DAYS_PER_WEEK;
        const end = start + DAYS_PER_WEEK;
        const showWeekRow = start < this.weekCols.length;

        this.weekRow?.toggleAttribute('data-hidden', !showWeekRow);
        this.continuationRow?.toggleAttribute('data-hidden', showWeekRow);

        if (showWeekRow) {
            this.weekCols.forEach((col, index) => {
                col.toggleAttribute('data-hidden', index < start || index >= end);
            });
            this.continuationCols.forEach((col) => col.setAttribute('data-hidden', ''));
        } else {
            const continuationStart = start - this.weekCols.length;

            this.weekCols.forEach((col) => col.setAttribute('data-hidden', ''));
            this.continuationCols.forEach((col, index) => {
                col.toggleAttribute('data-hidden', index < continuationStart || index >= continuationStart + DAYS_PER_WEEK);
            });
        }

        this.btnPrev.disabled = this.offset === 0;
        this.btnNext.disabled = this.offset >= this.maxOffset();
    }
}

const main = () => {
    document.querySelectorAll('.js-lp-viewing-schedule').forEach((root) => {
        new LpViewingSchedule(root);
    });
};

export default main;
